import { Component, effect, input, signal } from '@angular/core';
import { ProsellLogoComponent } from '@shared/components/prosell-logo/prosell-logo.component';

@Component({
  selector: 'app-loading-page',
  standalone: true,
  imports: [ProsellLogoComponent],
  templateUrl: './loading-page.component.html',
  styleUrls: ['./loading-page.component.scss'],
})
export class LoadingPageComponent {
  readonly title     = input('ProSell');
  readonly isLoading = input(true);

  protected readonly fadeOut = signal(false);

  constructor() {
    effect(() => {
      this.fadeOut.set(!this.isLoading());
    });
  }
}
